import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
	selector: 'app-jobs-interview-rules',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './jobs-interview-rules.component.html',
	styleUrl: './jobs-interview-rules.component.scss'
})
export class JobsInterviewRulesComponent {

	cameraDetected = false;
	micDetected = false;
	mediaStream: MediaStream | null = null;
	internetStatus = 'Checking...';
	internetSpeed = '';




	checkInternetSpeed() {

		const connection =
			(navigator as any).connection ||
			(navigator as any).mozConnection ||
			(navigator as any).webkitConnection;

		if (connection) {

			const downlink = connection.downlink;
			const effectiveType = connection.effectiveType;

			this.internetSpeed = `${downlink} Mbps`;

			if (downlink >= 5) {
				this.internetStatus = 'Good';
			} else if (downlink >= 1) {
				this.internetStatus = 'Average';
			} else {
				this.internetStatus = 'Poor';
			}

		} else {
			this.internetStatus = 'Unavailable';
		}
	}



	async runSystemCheck() {
		try {

			this.mediaStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });

			const videoTracks = this.mediaStream.getVideoTracks();
			const audioTracks = this.mediaStream.getAudioTracks();
			this.cameraDetected = videoTracks.length > 0;
			this.micDetected = audioTracks.length > 0;
			this.checkInternetSpeed();

		} catch (error) {

			this.cameraDetected = false;
			this.micDetected = false;

			console.error(error);
		}
	}


	goToHRMSPage() {
		window.open(`https://dev-frontend.acelucid.com/verification/C2KQ2JDOOXYUUNIT/36`)
	}


}
